<address class="pessoa-endereco-info-card">
    <div class="pessoa-endereco-info-card-endereco" *ngIf="endereco">
        <strong class="pessoa-endereco-info-card-title">
            <i class="fas fa-map-marker-alt"></i> Endereço
        </strong>
        <p>{{endereco.logradouro}} <span *ngIf="endereco.numero">, {{endereco.numero}}</span> <span *ngIf="endereco.complemento">, {{endereco.complemento}}</span></p>
        <p>{{endereco.bairro}}</p>
        <p>{{endereco.cep}} {{endereco.cidade?.nome}}, {{endereco.cidade?.estado?.uf}}</p>
    </div>

    <div class="pessoa-endereco-info-card-contato" *ngIf="contato">
        <strong class="pessoa-endereco-info-card-title">
            <i class="fas fa-phone"></i> Contato
        </strong>
        <p>{{contato.nome}}</p>
        <p>{{contato.fone}}</p>
        <p>{{contato.celular}}</p>
        <p>{{contato.email}}</p>
    </div>    
</address>